import { SubmitTourItComponent } from './submit-tour-it/submit-tour-it.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
	declarations: [SubmitTourItComponent],
	imports: [CommonModule, FormsModule, ReactiveFormsModule],
	exports: [SubmitTourItComponent]
})
export class SubmitTourItModule {}
